import dialog from './dialog'
import env from './env'
import AgReportErrorModal from '@/components/Modal/ReportError.vue'

function registerErrorHandler (Vue) {
  Vue.config.errorHandler = error => {
    reportError('Client-Error', String(error), error.stack)
  
    if (env.mode === 'development') {
      console.error(error)
    }
  }

  if (env.isWeb) {
    window.addEventListener('error', event => {
      reportError('Client-Error', String(event.error), event.error)
    })
    
    window.addEventListener('unhandledrejection', event => {
      reportError('Client-Error', 'Uncaught promise rejection', event.reason)
    })
  }
}

function reportError (type, message, details) {
  if (env.mode === 'development') {
    console.log(type, message, details)
  }
  
  return dialog.component(AgReportErrorModal, { type, message, details })
}

export {
  registerErrorHandler,
  reportError
}